export const ATTACHED_GARAGE = 'attached-garage';
export const DETACHED_GARAGE = 'detached-garage';
export const DRIVEWAY = 'driveway';
